import * as React from "react";
import clsx from "clsx";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { SidePanelTab, SidePanelTabConfig } from "./types";

interface Props {
  activeTab: SidePanelTab | null;
  isOpen: boolean;
  tabs: SidePanelTabConfig[];
  onTabChange: (tab: SidePanelTab) => void;
  onClose: () => void;
  children: React.ReactNode;
  widthClassName?: string;
  hideTabs?: boolean;
}

export const SidePanel = ({
  activeTab,
  isOpen,
  tabs,
  onTabChange,
  onClose,
  children,
  widthClassName = "w-1/2",
  hideTabs = false,
}: Props) => {
  const visibleTabs = tabs.filter(tab => tab.show !== false);

  return (
    <div
      className={clsx("relative flex flex-col border-l border-input bg-white/50 transition-opacity duration-300", {
        "opacity-100": isOpen,
        "w-0 opacity-0": !isOpen,
        [widthClassName]: isOpen,
      })}
    >
      {activeTab && (
        <>
          <div className="flex h-[52px] items-center justify-between border-b border-input px-4">
            {!hideTabs && (
              <div className="flex items-center gap-2">
                {visibleTabs.map(tab => (
                  <button
                    key={tab.id}
                    onClick={() => onTabChange(tab.id)}
                    className={clsx("rounded px-2 py-1 text-sm font-medium transition-all", {
                      "bg-ivory-mist-200 text-foreground": activeTab === tab.id,
                      "text-muted-foreground hover:bg-ivory-mist-100": activeTab !== tab.id,
                    })}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            )}
            <Button variant="outline" size="icon" className="h-8 w-8" onClick={onClose}>
              <X size={16} />
            </Button>
          </div>

          <div className="flex flex-1 flex-col overflow-hidden">{children}</div>
        </>
      )}
    </div>
  );
};
